import React, { useCallback } from 'react';

import { getDefaultAppName } from '../environments';
import { Alert, AlertActionLink } from '@patternfly/react-core';
import { useDispatch, useSelector } from 'react-redux';
import { snoozeNewVersionAlertFor, StoreState } from '../store/reducers';


const ALERT_SNOOZE_TIME_HOURS = 4;
const ALERT_SNOOZE_TIME_IN_MS = ALERT_SNOOZE_TIME_HOURS * 60 * 60 * 1000;

const NewVersionAlert = () => {
    const dispatch = useDispatch();

    const handleSnoozeClick = useCallback(() => {
        dispatch(snoozeNewVersionAlertFor(ALERT_SNOOZE_TIME_IN_MS));
    }, [dispatch]);

    const isNewAppVersionAvailable = useSelector((state: StoreState) => state.isNewAppVersionAvailable);
    const isSnoozed = useSelector((state: StoreState) => state.isNewVersionAlertSnoozing);

    if (isNewAppVersionAvailable && !isSnoozed) {
        return (
            <Alert
                title="A new version is available"
                actionLinks={<AlertActionLink onClick={handleSnoozeClick}>Snooze for 4 hours.</AlertActionLink>}
            >
                <span>A new version of {getDefaultAppName()} is available. Please save your work and refresh this page to change to the latest version as soon as possible.</span>
            </Alert>
        );
    }
    else {
        return null;
    }
}

export default NewVersionAlert;
